import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'mee-login-snackbar',
  templateUrl: './login-snackbar.component.html',
  styleUrls: ['./login-snackbar.component.scss']
})
export class LoginSnackbarComponent {
  readonly url = environment.vsiteUrl;

  get vSiteText(): string {
    const { vsiteUrl } = environment;

    return vsiteUrl.includes('vsite.meemim.com') ? vsiteUrl : vsiteUrl.split('vsite')[0] + 'vsite';
  }
}
